import {Box, Grid, Stack, Typography} from '@mui/material';
import React, {useMemo} from 'react';
import {t} from 'i18next';
import {IChild} from '../heated-map-panel/TypesHeatMap';
import {Close} from '@mui/icons-material';
import SidePanelConceptExp from '../side-Panel/SidePanelConceptExp';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import {useNavigate} from 'react-router-dom';

interface ICartProps {
  cartItems: IChild[];
  setCartItems: React.Dispatch<React.SetStateAction<IChild[]>>;
  onMenuAction?: (actionId: string) => void;
  onActionSelect?: (actionId: string) => void;
  sourceDetails?: {[key: string]: any};
  getDoActionData?: (data: {
    operationType?: string;
    sourceDetails?: {[key: string]: any};
  }) => {selectedList?: object; destinationList?: object};
  getSourceDetails?: (
    sourceDetails: {[key: string]: any},
    forAPI?: string
  ) => {
    [key: string]: any;
  };
  showToastFromParent?: (config: any) => void;
  onActionPick?: (
    action: any,
    callBackForDoc?: (docId: string, source: string) => void
  ) => void;
  validateBeforeBulkAction?: () => boolean;
}

const textsCommonPath =
  'reports.dataAnalysisReport.conceptExplorer.selectedResultsPanel';

const Cart = ({
  cartItems = [],
  setCartItems,
  onMenuAction,
  onActionSelect,
  sourceDetails,
  getDoActionData,
  getSourceDetails,
  showToastFromParent,
  onActionPick,
  validateBeforeBulkAction,
}: ICartProps) => {
  const handleClose = (id: string) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  const uniqueDocumentsCount = useMemo(() => {
    return cartItems.reduce((sum, item) => sum + item.size, 0);
  }, [cartItems]);

  return (
    <>
      <Box className="cart-header" data-testid="arr-selected-unique-docs-count">
        <Stack className="cart-actions-section">
          <Typography
            className="typo-text subhead2_size"
            tabIndex={0}
            data-testid={`cart-title`}
          >
            {t(`${textsCommonPath}.title`)}
          </Typography>
          <SidePanelConceptExp
            cartItems={cartItems}
            onMenuAction={onMenuAction}
            sourceDetails={sourceDetails}
            getDoActionData={getDoActionData}
            getSourceDetails={getSourceDetails}
            showToastFromParent={showToastFromParent}
            onActionPick={onActionPick}
            validateBeforeBulkAction={validateBeforeBulkAction}
            onActionSelect={onActionSelect}
          />
        </Stack>
        <Typography
          className="typo-text body4_size text-body-strong"
          tabIndex={0}
          data-testid="txt-unique-doc-count"
        >
          {t(`${textsCommonPath}.clusterCount`, {count: uniqueDocumentsCount})}
        </Typography>
      </Box>
      <Box>
        {cartItems?.length === 0 ? (
          <Box className="cart-empty-state">
            <Typography
              className="typo-text body5_size text-body-subtle"
              data-testid={`cart-empty-text`}
            >
              {t(`${textsCommonPath}.emptyState`)}
            </Typography>
          </Box>
        ) : (
          <Grid
            container
            className="cart-items-container"
            columnSpacing={{xs: 1}}
          >
            {cartItems.map((item: any, index) => (
              <Grid
                size={{xs: 6}}
                key={item.id}
                className="cart-item"
                data-testid={`arr-cluster-in-cart-${index}`}
              >
                <Stack className="close-icon-stack">
                  <ArrIconButton
                    icon={<Close />}
                    ariaLabel="remove item"
                    size="small"
                    onClick={() => handleClose(item.id)}
                    testId={`cart-remove-item-icon-button--${index}`}
                  />
                </Stack>
                <Stack
                  sx={{width: '100%', display: 'flex', alignItems: 'start'}}
                >
                  <Typography
                    className="typo-text body4_size"
                    tabIndex={0}
                    data-testid={`cart-typography-name-${index}`}
                  >
                    {item.name}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </>
  );
};

export default Cart;
